export default __webpack_public_path__ + "static/media/DarkBlue0007.587619d4.png";